import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize[2]}px;
  font-weight: normal;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.neutral.neutral75};
`;
